
import Vue from "vue";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import { View } from "@/models/view";

export default Vue.extend({
	props: {
		view: {
			type: Object as ()=>View,
			required: true
		}
	},
	methods: {
		setDefaultNewSaleTypeID(value:number){
			this.view.MetaData.NewBankTypeID = value;
		}
	},
	components: {
		AppSelectBankType
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
